var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { inline: "", "label-width": "100px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "调整优先级", prop: "level" } },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    placement: "right",
                    title: "拖拽条件调整优先级顺序",
                    width: "250",
                    trigger: "click",
                  },
                },
                [
                  _c(
                    "draggable",
                    {
                      staticStyle: { width: "100%", "min-height": "25px" },
                      attrs: {
                        list: _vm.prioritySortList,
                        group: "from",
                        options: _vm.sortOption,
                      },
                    },
                    _vm._l(_vm.prioritySortList, function (cd, index) {
                      return _c(
                        "div",
                        {
                          class: {
                            "drag-no-choose": true,
                            "drag-hover": cd.id === _vm.selectedNode.id,
                          },
                        },
                        [
                          _c("ellipsis", {
                            staticStyle: { width: "160px" },
                            attrs: { "hover-tip": "", content: cd.name },
                          }),
                          _c("div", [_vm._v("优先级 " + _vm._s(index + 1))]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        slot: "reference",
                        icon: "el-icon-sort",
                        size: "small",
                      },
                      slot: "reference",
                    },
                    [_vm._v("第" + _vm._s(_vm.nowNodeLeave + 1) + "级")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "条件组关系", "label-width": "150px" } },
            [
              _c("el-switch", {
                attrs: {
                  "active-color": "#409EFF",
                  "inactive-color": "#c1c1c1",
                  "active-value": "AND",
                  "inactive-value": "OR",
                  "active-text": "且",
                  "inactive-text": "或",
                },
                model: {
                  value: _vm.config.groupsType,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "groupsType", $$v)
                  },
                  expression: "config.groupsType",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "条件组表达式" } },
            [
              _c("el-input", {
                attrs: {
                  size: "mini",
                  placeholder: "输入条件组关系表达式  &为与，|为或",
                },
                model: {
                  value: _vm.config.expression,
                  callback: function ($$v) {
                    _vm.$set(_vm.config, "expression", $$v)
                  },
                  expression: "config.expression",
                },
              }),
              _c("span", { staticClass: "item-desc" }, [
                _vm._v("使用表达式构建复杂逻辑，例如: (A & B) | C"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              staticStyle: { margin: "0 15px 15px 0" },
              attrs: {
                type: "primary",
                size: "mini",
                icon: "el-icon-plus",
                round: "",
              },
              on: { click: _vm.addConditionGroup },
            },
            [_vm._v(" 添加条件组 ")]
          ),
          _c("span", { staticClass: "item-desc" }, [
            _vm._v("只有必填选项才能作为审批条件"),
          ]),
        ],
        1
      ),
      _c("group-item"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }